const converterNumero = (valor: string) => {
    valor = valor.replace(/[^\d,]/g, '').replace(',', '.')

    return Number(valor)
}

export default converterNumero
